import React from 'react';
import { View } from 'react-native';
import Text from '@/components/Typography/Text';
import { MONO } from '@/components/Landing/landingTokens';
import { CODING_TIERS } from '@/constants/apiContent';
import { ApiBody, ApiEyebrow, ApiLink, ApiSection, ApiSplit, ApiTitle, useApiDesign } from './ApiEditorial';

function ApiAuto() {
  const { c, compact, mobile } = useApiDesign();
  return (
    <ApiSection label="Automatic model routing" background={c.soft}>
      <ApiSplit style={{ alignItems: compact ? 'stretch' : 'center' }}>
        <View style={{ flex: compact ? undefined : 1, minWidth: 0 }}>
          <ApiEyebrow>Meet Auto Router</ApiEyebrow>
          <ApiTitle>The right model.{'\n'}For the task at hand.</ApiTitle>
          <ApiBody style={{ marginTop: 22 }}>Choose a model by name, or let Auto route your request. For coding, it considers complexity to match the work ahead.</ApiBody>
          <ApiLink href="/docs/api" style={{ marginTop: 18 }}>Explore automatic routing</ApiLink>
        </View>
        <View style={{ flex: compact ? undefined : 1.1, minWidth: 0, padding: mobile ? 24 : 32, borderRadius: 24, backgroundColor: c.surface, borderWidth: 1, borderColor: c.rule }}>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', gap: 12, paddingBottom: 26 }}>
            <Text style={{ color: c.ink, fontFamily: MONO, fontSize: 18, lineHeight: 26 }}>model="auto"</Text>
            <Text style={{ color: c.muted, fontSize: 12 }}>Coding complexity</Text>
          </View>
          {CODING_TIERS.map((item, index) => (
            <View key={item.tier} style={{ flexDirection: 'row', gap: 20, alignItems: 'center', paddingVertical: 22, borderTopWidth: 1, borderTopColor: c.rule }}>
              <View aria-hidden style={{ width: 32, height: 28, flexDirection: 'row', alignItems: 'flex-end', gap: 4 }}>
                {[0, 1, 2].map(bar => <View key={bar} style={{ width: 6, height: 10 + bar * 8, borderRadius: 2, backgroundColor: bar <= index ? c.ink : c.rule }} />)}
              </View>
              <View style={{ flex: 1, gap: 4 }}>
                <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 17, lineHeight: 24, textTransform: 'capitalize' }}>{item.tier}</Text>
                <Text style={{ color: c.secondary, fontSize: 13, lineHeight: 21 }}>{item.rule}.</Text>
              </View>
            </View>
          ))}
          <Text style={{ color: c.secondary, fontSize: 12, lineHeight: 21, marginTop: 4 }}>For supported coding agents, the selected model stays consistent through a tool loop. A new task can be routed again.</Text>
        </View>
      </ApiSplit>
      <Text style={{ color: c.muted, fontSize: 12, lineHeight: 21, marginTop: 30 }}>Billed for the model that runs. See the selected model in the response and the X-Gab-Routed-Model header.</Text>
    </ApiSection>
  );
}
export default React.memo(ApiAuto);
